












































import Vue from "vue";

export default Vue.extend({
  name: "vc-plan-option-credit-card-v1",
  props: {
    currency: { default: undefined }
  }
});
